import Main from '@/components/Main'
import Admin from '@/components/Admin'


export const appRouter = [
  	{
        path: '/',
        title: '首页',
        name: 'main',
        component: Main,
        children: [
            { path: 'home', title: '安装', name: 'home', component: resolve => { require(['../components/Home/'], resolve); } },
            { path: 'f', title: '反馈', name: 'f', component: resolve => { require(['../components/Feed/'], resolve); } },
        ]
    },
    {
        path: '/admin',
        title: '管理端',
        name: 'admin',
        component: Admin,
        children: [
            { path: 'list', title: '常见问题', name: 'list', component: resolve => { require(['../components/adList/'], resolve); } },
            { path: 'listInfo', title: '编辑', name: 'listInfo', component: resolve => { require(['../components/adEdit/'], resolve); } },
            { path: 'feed', title: '用户提问', name: 'feed', component: resolve => { require(['../components/adFeed/'], resolve); } },
            { path: 'feedInfo', title: '提问编辑', name: 'feedInfo', component: resolve => { require(['../components/adFeedInfo/'], resolve); } },
            { path: 'report', title: '统计', name: 'report', component: resolve => { require(['../components/report/'], resolve); } },
        ]
    },
]
export const routers = [
	...appRouter
]


// WEBPACK FOOTER //
// ./src/router/index.js